import React, { Component } from 'react';
import DatePicker from 'react-date-picker';
import LabeledMonthRange from './labeledMonthRange';
import PropTypes from 'prop-types';

class LabeledMonthRangePicker extends Component {

    state = {
        showRange: true,
    }

    toggle = () => {

        this.setState( {
            showRange: !this.state.showRange,
        } );

    }

    handleMonthChange = ( props, name, date ) => {

        this.props.onChange( props, name, date );

    }

    render () {

        return (

            <div className="month-range-picker">
                <label>
                    {this.props.label}
                    <span className={`asterisk-icon ${this.props.isRequired ? 'mandatory' : ''}`}>
                        <i className="fa fa-asterisk" />
                    </span>
                </label>
                <div className={`serach-range ${!this.state.showRange ? 'show' : ''}`}>
                    <DatePicker
                        className={this.props.className}
                        name={this.props.name}
                        value={this.props.from}
                        onChange={this.handleMonthChange.bind( this, this.props, 'buildMonth' )}
                        format={this.props.dateFormat}
                        maxDate={new Date()}
                        maxDetail="year"
                        monthPlaceholder="MM"
                        yearPlaceholder="YYYY"
                    />

                </div>
                <div>
                    <div className={`serach-range ${this.state.showRange ? 'show' : ''}`}>
                        <LabeledMonthRange
                            className={this.props.className}
                            name={this.props.name}
                            from={this.props.from}
                            to={this.props.to}
                            onChange={this.handleMonthChange.bind( this )}
                            dateFormat={this.props.dateFormat}
                        />
                    </div>
                    <label className="serach-range-label" onClick={this.toggle}>
                        <i className={`arrow-icon fa ${!this.state.showRange ? 'fa-angle-down' : 'fa-angle-up'}`} />
                                        Search Range
                    </label>
                </div>

            </div>

        );

    }

}

LabeledMonthRangePicker.displayName = 'LabeledMonthRangePicker';
LabeledMonthRangePicker.propTypes = {
    name: PropTypes.string.isRequired,
    label: PropTypes.string.isRequired,
    className: PropTypes.string.isRequired,
    isRequired: PropTypes.bool.isRequired,
    from: PropTypes.number.isRequired,
    to: PropTypes.number.isRequired,
    dateFormat: PropTypes.string.isRequired,
    onChange: PropTypes.func.isRequired,
};

export default LabeledMonthRangePicker;
